function datePickerForm() {
  function roundToNearestHalfHour(date) {
    const roundedDate = new Date(date);
    const minutes = roundedDate.getMinutes();
    const roundedMinutes = Math.round(minutes / 30) * 30;

    roundedDate.setMinutes(roundedMinutes);
    roundedDate.setSeconds(0);
    roundedDate.setMilliseconds(0);

    // If the minutes are 60, roll over to the next hour
    // and set the minutes back to 0
    if (roundedMinutes === 60) {
      roundedDate.setMinutes(0);
      roundedDate.setHours(roundedDate.getHours() + 1);
    }

    // Set variables for the date and time
    const year = roundedDate.getFullYear();
    const month = String(roundedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(roundedDate.getDate()).padStart(2, "0");
    const hours = String(roundedDate.getHours()).padStart(2, "0");
    const minutesFormatted = String(roundedDate.getMinutes()).padStart(2, "0");

    // Use the above variables to create a string compatible with the datetime-local value
    return `${year}-${month}-${day}T${hours}:${minutesFormatted}`;
  }

  return {
    hasError: false,

    verifyDatetime() {
      const errorEl = document.querySelector(".info-box__error");
      const submitButton = document.querySelector("#date-picker-form-submit");

      const roundedDate = roundToNearestHalfHour(this.$el.value);

      // Check that the date is Monday to Friday, between 8am and 4:30pm
      const date = new Date(roundedDate);
      const day = date.getDay();
      const hours = date.getHours();

      // Check if the date is invalid (weekend or out of business hours)
      const isInvalidDate = day === 0 || day === 6 || hours < 8 || hours > 16;

      if (isInvalidDate && !this.hasError) {
        // Show error if date is invalid and no error is currently shown
        gsap.set(errorEl, {
          display: "block",
          onComplete: () => {
            gsap.to(errorEl, { autoAlpha: 1, duration: 0.5 });
            submitButton.disabled = true;
          },
        });
        this.hasError = true; // Set error state
      } else if (!isInvalidDate && this.hasError) {
        // Hide error if date is valid and error is currently shown
        gsap.to(errorEl, {
          autoAlpha: 0,
          duration: 0.5,
          onComplete: () => {
            gsap.set(errorEl, { display: "none" });
            submitButton.disabled = false;
          },
        });
        this.hasError = false; // Reset error state
      }

      // Update the input value to the rounded date
      this.$el.value = roundToNearestHalfHour(this.$el.value);
    },

    handleSubmitted() {
      const banner = document.querySelector(
        ".shopify-section .primary-copy"
      ).parentElement;
      gsap.to(banner, {
        autoAlpha: 0,
        onComplete: () => {
          gsap.set(banner, { display: "none" });
          gsap.to(".date-picker-form__submitted", {
            autoAlpha: 1,
          });
        },
      });
    },
  };
}
